import React, {Component} from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LoadingPane, ConfirmModalWindow, PagingControl, accessibilityNotificationsEmitter, ImageDisplay } from '@social-solutions/ssg-forms';
import { Title } from '../../layout';
import { track } from '../../tracking';
import { authActions } from '../../auth';
import * as messagesActions from './messages.actions';
import { ssgFormsAdapters } from '../../common';
import SingleMessage from './single-message';
import * as messageConstants from './message-constants';
import './messages.scss';

export class AllMessagesComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      messagesViewed: false,
    }
  }
  componentDidMount() {
    const { messagesActions, auth } = this.props;
    const { messagesViewed } = this.state;
    const { fetchAllMessages, recordMessagesViewed } = messagesActions;
    const { currentSession, participantInfo } = auth;
    const { user } = currentSession || {};
    const { id: participantId } = user || {};

    const { data: participant } = participantInfo || {};
    if(!!participant && !messagesViewed) {
      // let the api know that the messages page was viewed
      recordMessagesViewed();
      this.setState({messagesViewed: true});
    }
    fetchAllMessages(participantId);
  }

  componentWillUpdate(nextProps, nextState) {
    const { messagesActions, auth } = this.props;
    const { fetchAllMessages } = messagesActions;
    const { currentSession } = auth;
    const { user } = currentSession || {};
    const { id : participantId } = user || {};
    fetchAllMessages(participantId);
  }

  componentDidUpdate(prevProps, prevState) {
    const { dashboardMessages : prevMessages } = prevProps;
    const { dismissTarget : previousMessage } = prevMessages;
    const { dashboardMessages, auth, messagesActions } = this.props;
    const { messagesViewed } = this.state;
    const { participantInfo } = auth;
    const { data: participant } = participantInfo || {};
    const { dismissTarget: selectedMessage } = dashboardMessages;

    if (selectedMessage && !previousMessage) {
      var confirmDismiss = document.getElementById('confirm-dismiss');
      if (confirmDismiss) confirmDismiss.focus();
    }

    if(!!participant && !messagesViewed) {
      // let the api know that the messages page was viewed
      messagesActions.recordMessagesViewed();
      this.setState({messagesViewed: true});
    }
  }

  /** update the new message count */
  componentWillUnmount() {
    const { messagesActions, authActions, auth } = this.props;
    const { fetchStats } = messagesActions;
    const { currentSession } = auth;
    const { user } = currentSession || {};
    const { id: participantId } = user || {};
    fetchStats(participantId);
    authActions.fetchParticipantInfo();
  }

  mapItem(item) {
    const { auth } = this.props;
    const { participantInfo } = auth;
    const { data: participant } = participantInfo || {};
    const { messageViewDateUtc } = participant || {};

    return (
      <SingleMessage key={item.id} item={item} messageViewDateUtc={messageViewDateUtc} handleDismiss={id => this.handleOpenModal(id)} />
    );
  }

  handleOpenModal(id) {
    const { messagesActions } = this.props;
    const { setDismissTarget } = messagesActions;
    accessibilityNotificationsEmitter.assertive(messageConstants.modalText);
    setDismissTarget(id);

    track.event.dashboard.message.dismiss();
  }

  handleDismiss(id) {
    const { messagesActions } = this.props;
    const { setDismissTarget, dismissMessage } = messagesActions;
    dismissMessage(id);
    setDismissTarget(null);
    accessibilityNotificationsEmitter.assertive(messageConstants.dismissText);
  }

  handleDismissConfirm(confirmed, dismissTarget) {
    const { messagesActions } = this.props;
    const { setDismissTarget } = messagesActions;
    if(confirmed) {
      this.handleDismiss(dismissTarget);
    }
    else {
      setDismissTarget(null)
    }
  }

  render() {
    const { auth, dashboardMessages, messagesActions } = this.props;
    const { participantInfo } = auth;
    const { allMessagesState, pagingData, dismissTarget } = dashboardMessages;
    const { data } = allMessagesState || {};
    const { totalResults, results, currentPage } = data || {totalResults: 0, results: [], currentPage: 1};
    const { itemsPerPage } = pagingData || {};
    const { changePageNumber } = messagesActions;

    const pagingProps = {
      itemsPerPage,
      totalItemCount: totalResults,
      currentPage,
      hideTopPagingButtonGroup: true,
      onChangePage: page => changePageNumber(page),
      css: {
        display: 'ssg-forms-page message-page-controls',
      }
    }

    return (
      <div>
        <Title title="Notifications"/>
        <h1 className="ssg-forms-text xl page-title">Notifications</h1>
        {!!data && totalResults === 0 ?  (
          <div className="centered-content">
            <ImageDisplay
              src="/Inbox.png"
              primaryText="You're All Caught Up!"
              secondaryText="Your notification inbox is empty."/>
          </div>
        ) : (
          <div>
            <ConfirmModalWindow
              id="dismiss-modal"
              title='Dismiss Notification'
              overrideShow={!!dismissTarget}
              hideCloseButton={true}
              onClose={(e, confirmed) => this.handleDismissConfirm(confirmed, dismissTarget)}>
              {messageConstants.modalText}
            </ConfirmModalWindow>
            <LoadingPane
              id="participant"
              loadingState={ssgFormsAdapters.convertLoadingState(participantInfo)}
              loadingMessage="Loading Notifications...">
              <LoadingPane
                id="messages"
                loadingState={ssgFormsAdapters.convertLoadingState(allMessagesState)}
                loadingMessage="Loading Notifications...">
                <PagingControl {...pagingProps}>
                  <div className="messageSection">
                    {results && results.map((item) => this.mapItem(item))}
                  </div>
                </PagingControl>
              </LoadingPane>
            </LoadingPane>
          </div>
        )}
      </div>
    );
  }
}

AllMessagesComponent.propTypes = {
  dashboardMessages : PropTypes.any,
  auth : PropTypes.any,
  messagesActions : PropTypes.any,
};

const mapStateToProps = ({ dashboardMessages, auth }) => {
  return {
    dashboardMessages,
    auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    messagesActions: bindActionCreators(messagesActions, dispatch),
    authActions: bindActionCreators(authActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AllMessagesComponent);



// WEBPACK FOOTER //
// src/dashboard/messages/all-messages.component.js